import { render, staticRenderFns } from "./ContactShipping.vue?vue&type=template&id=859e2690&scoped=true&"
import script from "./ContactShipping.vue?vue&type=script&lang=js&"
export * from "./ContactShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859e2690",
  null
  
)

export default component.exports